import type { NgDocCategory } from '@ng-doc/core';

const PipesCategory: NgDocCategory = {
  order: 4,
  title: 'Pipes'
};

export default PipesCategory;